var $ = require('jquery');

var self = {};

self.initialise = function () {
    const $navBtn = $('.js-res-nav-btn');
    const $nav = $('.js-main-nav');

    const ACTIVE = 'active';
    const NOSCROLL = 'no-scroll';

    function initNav() {

        $navBtn.on('click', (e) => {
            const $this = e.currentTarget;
            if ($($this).hasClass(ACTIVE)) {
                $($this).removeClass(ACTIVE);
                $nav.removeClass(ACTIVE);
                $('html').removeClass(NOSCROLL);
            } else {
                $($this).addClass(ACTIVE);
                $nav.addClass(ACTIVE);
                $('html').addClass(NOSCROLL);
            }
        });
    }

    initNav();
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-nav.js